import { mapState } from 'vuex';
import { get } from 'lodash';
import ApiService from '@/services/apiService';
import CoreCsvExportEmail from './email';
const TIME_RANGE_OPTIONS = {
  CURRENT_HOUR: 'CURRENT_HOUR',
  LAST_HOUR: 'LAST_HOUR',
  CURRENT_DAY: 'CURRENT_DAY',
  LAST_DAY: 'LAST_DAY',
  CURRENT_WEEK: 'CURRENT_WEEK',
  LAST_WEEK: 'LAST_WEEK',
  CURRENT_MONTH: 'CURRENT_MONTH',
  LAST_MONTH: 'LAST_MONTH',
  CURRENT_YEAR: 'CURRENT_YEAR',
  LAST_YEAR: 'LAST_YEAR'
};
const TIME_RANGES = {
  hourly: [TIME_RANGE_OPTIONS.CURRENT_HOUR, TIME_RANGE_OPTIONS.LAST_HOUR],
  daily: [TIME_RANGE_OPTIONS.CURRENT_HOUR, TIME_RANGE_OPTIONS.LAST_HOUR, TIME_RANGE_OPTIONS.CURRENT_DAY, TIME_RANGE_OPTIONS.LAST_DAY],
  weekly: [TIME_RANGE_OPTIONS.CURRENT_HOUR, TIME_RANGE_OPTIONS.LAST_HOUR, TIME_RANGE_OPTIONS.CURRENT_DAY, TIME_RANGE_OPTIONS.LAST_DAY, TIME_RANGE_OPTIONS.CURRENT_WEEK, TIME_RANGE_OPTIONS.LAST_WEEK],
  monthly: [TIME_RANGE_OPTIONS.CURRENT_HOUR, TIME_RANGE_OPTIONS.LAST_HOUR, TIME_RANGE_OPTIONS.CURRENT_DAY, TIME_RANGE_OPTIONS.LAST_DAY, TIME_RANGE_OPTIONS.CURRENT_WEEK, TIME_RANGE_OPTIONS.LAST_WEEK, TIME_RANGE_OPTIONS.CURRENT_MONTH, TIME_RANGE_OPTIONS.LAST_MONTH],
  yearly: [TIME_RANGE_OPTIONS.CURRENT_HOUR, TIME_RANGE_OPTIONS.LAST_HOUR, TIME_RANGE_OPTIONS.CURRENT_DAY, TIME_RANGE_OPTIONS.LAST_DAY, TIME_RANGE_OPTIONS.CURRENT_WEEK, TIME_RANGE_OPTIONS.LAST_WEEK, TIME_RANGE_OPTIONS.CURRENT_MONTH, TIME_RANGE_OPTIONS.LAST_MONTH, TIME_RANGE_OPTIONS.CURRENT_YEAR, TIME_RANGE_OPTIONS.LAST_YEAR]
};
const AGGREGATE_FUNCTIONS = {
  ALL: 'ALL',
  LAST: 'LAST',
  SUM: 'SUM',
  MAX: 'MAX',
  AVG: 'AVG'
};
const AGGREGATE_PERIOD = {
  hourly: 'hourly',
  daily: 'daily',
  weekly: 'weekly'
};
export default {
  name: 'CoreCsvExportDialogScheduled',
  components: {
    CoreCsvExportEmail
  },
  props: {
    editObject: {
      type: Object,
      default: () => null
    },
    copyMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      dialogIsReady: false,
      name: null,
      accountId: null,
      parentId: null,
      parentScopeId: null,
      filter: [],
      filterType: 'digitalTwin',
      frequency: {
        repeat: 'monthly',
        month: null,
        day: null,
        hour: null,
        minute: null,
        weekDay: null
      },
      validFrequency: false,
      validEmails: true,
      validCsvOptions: true,
      validThirdPartyData: false,
      timeRange: TIME_RANGE_OPTIONS.LAST_HOUR,
      jobs: [],
      searchTotalCount: null,
      dataAggregationObj: {
        functionName: AGGREGATE_FUNCTIONS.ALL,
        aggregatePeriod: null
      },
      selectedAggregationKey: AGGREGATE_FUNCTIONS.ALL,
      timezone: null,
      isReadonly: false,
      search: [],
      searchOperator: 'AND',
      showStructureSection: false,
      allDriversVariables: [],
      selectedDriversVariables: [],
      stateIdentifiers: [],
      customProperties: [],
      references: [],
      drivers: [],
      selectedStates: [],
      stateIdSearchInput: null,
      emailsData: {
        emails: [''],
        formIsValid: true,
        selectedMailConnector: null,
        attachFile: false
      },
      csvOptions: {
        headers: [],
        includeHeaders: true,
        clusterPerPacket: false
      },
      thirdPartyData: {
        selectedOutboundConnector: null,
        payload: null,
        bridgeId: null
      },
      selectedOption: 'downloadFileFromNiotix',
      mailConnectors: [],
      outboundConnectors: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    dataAggregationItems() {
      return [{
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.ALL'),
        value: {
          functionName: AGGREGATE_FUNCTIONS.ALL,
          aggregatePeriod: null
        },
        key: AGGREGATE_FUNCTIONS.ALL
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.LAST'),
        value: {
          functionName: AGGREGATE_FUNCTIONS.LAST,
          aggregatePeriod: null
        },
        key: AGGREGATE_FUNCTIONS.LAST
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.MAX'),
        value: {
          functionName: AGGREGATE_FUNCTIONS.MAX,
          aggregatePeriod: null
        },
        disabled: this.csvOptions.clusterPerPacket,
        key: AGGREGATE_FUNCTIONS.MAX
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.SUM'),
        value: {
          functionName: AGGREGATE_FUNCTIONS.SUM,
          aggregatePeriod: null
        },
        disabled: this.csvOptions.clusterPerPacket,
        key: AGGREGATE_FUNCTIONS.SUM
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.AVG-hourly'),
        value: {
          functionName: AGGREGATE_FUNCTIONS.AVG,
          aggregatePeriod: AGGREGATE_PERIOD.hourly
        },
        disabled: this.csvOptions.clusterPerPacket,
        key: `${AGGREGATE_FUNCTIONS.AVG}-${AGGREGATE_PERIOD.hourly}`
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.AVG-daily'),
        value: {
          functionName: AGGREGATE_FUNCTIONS.AVG,
          aggregatePeriod: AGGREGATE_PERIOD.daily
        },
        disabled: this.csvOptions.clusterPerPacket,
        key: `${AGGREGATE_FUNCTIONS.AVG}-${AGGREGATE_PERIOD.daily}`
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.AVG-weekly'),
        value: {
          functionName: AGGREGATE_FUNCTIONS.AVG,
          aggregatePeriod: AGGREGATE_PERIOD.weekly
        },
        disabled: this.csvOptions.clusterPerPacket,
        key: `${AGGREGATE_FUNCTIONS.AVG}-${AGGREGATE_PERIOD.weekly}`
      }];
    },
    searchTotalCountMessage() {
      if (this.searchTotalCount === null || this.searchTotalCount === undefined || (this.filter || []).length === 0) {
        return null;
      }
      const typeDevice = this.filterType === 'digitalTwin' ? this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.digitalTwins') : this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.virtualDevices');
      if (this.searchTotalCount === -1) {
        return this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.totalCountError', {
          devices: typeDevice
        });
      }
      return this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.totalCount', {
        count: this.searchTotalCount,
        devices: typeDevice
      });
    },
    formIsValid() {
      if (this.selectedOption === 'sendoutDownloadLink') {
        return Boolean(this.name && this.accountId && this.validFrequency && this.timeRange && this.validEmails && this.validCsvOptions && this.mailConnectors.length);
      } else if (this.selectedOption === 'forwardToThirdParty') {
        return Boolean(this.name && this.accountId && this.validFrequency && this.timeRange && this.validCsvOptions && this.validThirdPartyData && this.outboundConnectors.length);
      } else {
        return Boolean(this.name && this.accountId && this.validFrequency && this.timeRange && this.validCsvOptions);
      }
    },
    timeRangeItems() {
      const ranges = TIME_RANGES[(this.frequency || {}).repeat] || [];
      return ranges.map(range => {
        return {
          value: range,
          text: this.$i18n_t(`BackgroundJobs.ScheduledExports.dialog.timeRange.items.${range}`)
        };
      });
    },
    forwardOptions() {
      return [{
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.downloadFileFromNiotix'),
        value: 'downloadFileFromNiotix'
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.sendoutDownloadLink'),
        value: 'sendoutDownloadLink'
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.forwardToThirdParty'),
        value: 'forwardToThirdParty'
      }];
    }
  },
  watch: {
    editObject: {
      handler(newVal) {
        if (newVal !== null) {
          this.$nextTick(() => {
            this.initEditDialog();
          });
        } else {
          this.dialogIsReady = true;
        }
      },
      immediate: true
    },
    accountId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchBridges();
        ApiService.digitalTwinFetchChildren(this, null, 0, 1, null, ['bare'], false, newVal).then(res => this.parentId = get(res, 'digitaltwins[0].id', null)).catch(() => this.$snack(this.$i18n_t('Common.digitalTwins.errorFindingDTwins'), 'error'));
        this.fetchFilterDeviceCount(this.filterType, this.filter);
        if (newVal && oldVal) {
          this.selectedOption = 'downloadFileFromNiotix';
        }
      }
    },
    parentId(parentId) {
      ApiService.digitalTwinGet(this, parentId).then(twin => {
        this.parentScopeId = twin.scopeId;
        this.fetchFilterDeviceCount(this.filterType, this.filter, this.filterOperator);
      }).catch(error => {
        console.error(error);
      });
    },
    filterType(newVal, oldVal) {
      this.showStructureSection = newVal !== 'digitalTwin';

      // https://digimondo.atlassian.net/browse/RD-6673
      // the filterType is 'digitalTwin' per default but in read-only mode
      // it might change according to the editObject to 'virtualDevice'
      // check if dialog is read-only mode and if so do nothing to prevent
      // overwriting search, stateIdentifiers, selectedStates and searchTotalCount
      if (this.isReadonly) {
        return;
      }
      if (newVal !== oldVal) {
        this.search = [];
        this.allDriversVariables = [];
        this.stateIdentifiers = [];
        this.customProperties = [];
        this.references = [];
        this.drivers = [];
        this.selectedStates = [];
        this.searchTotalCount = null;
      }
    },
    drivers() {
      this.populateDrivers();
    },
    'frequency.formIsValid'() {
      this.validFrequency = this.frequency.formIsValid;
    },
    'emailsData.formIsValid'() {
      this.validEmails = this.emailsData.formIsValid;
    },
    'csvOptions.formIsValid'() {
      this.validCsvOptions = this.csvOptions.formIsValid;
    },
    'thirdPartyData.formIsValid'() {
      this.validThirdPartyData = this.thirdPartyData.formIsValid;
    },
    'frequency.repeat'() {
      const ranges = TIME_RANGES[(this.frequency || {}).repeat] || [];
      if (!ranges.includes(this.timeRange)) {
        this.timeRange = ranges[0];
      }
    },
    'csvOptions.clusterPerPacket': {
      handler(newValue) {
        if (!newValue) {
          // clear selected drivers variables when clusterPerPacket is disabled
          this.selectedDriversVariables = [];
        }
      },
      immediate: true
    },
    selectedAggregationKey(newVal) {
      this.syncAggregatePeriod(newVal);
    }
  },
  mounted() {
    this.showStructureSection = this.filterType !== 'digitalTwin';
  },
  methods: {
    getFunctionName(item) {
      if (item && typeof item === 'object' && item.value && typeof item.value === 'object') {
        return item.value.functionName;
      }
      return null;
    },
    syncAggregatePeriod(newFunctionName) {
      const selectedFunction = this.dataAggregationItems.find(item => item.key === newFunctionName);
      this.dataAggregationObj.functionName = newFunctionName;
      this.dataAggregationObj.aggregatePeriod = selectedFunction ? selectedFunction.value.aggregatePeriod : null;
    },
    initEditDialog() {
      this.isReadonly = true;
      const criteria = get(this, 'editObject.parameters.criteria', {});
      this.name = this.editObject.title;
      this.accountId = this.editObject.tenantId;
      this.timezone = this.editObject.timezone;
      this.timeRange = criteria.range || TIME_RANGE_OPTIONS.LAST_HOUR;
      this.selectedAggregationKey = criteria.aggregateFunction + (criteria.aggregatePeriod ? `-${criteria.aggregatePeriod}` : '') || AGGREGATE_FUNCTIONS.ALL;
      this.frequency = this.fromCrontab(this.editObject.timeExpression);
      this.filterType = criteria.type;
      this.search = (criteria.search_items || []).map(item => ({
        param: item.param || item.variable,
        search: item.search,
        key: item.key,
        condition: item.condition || 'is'
      }));
      const emailsData = get(this, 'editObject.parameters.emailsData', {});
      if (emailsData.bridgeId && emailsData.emails && emailsData.html) {
        this.emailsData = get(this, 'editObject.parameters.emailsData');
      }
      this.csvOptions = get(this, 'editObject.parameters.csvOptions');
      this.thirdPartyData = get(this, 'editObject.parameters.thirdPartyData', {});
      this.thirdPartyData.selectedOutboundConnector = get(this, 'editObject.parameters.thirdPartyData', {}).bridgeId;
      this.selectedOption = emailsData.html || emailsData.subject || emailsData.emails || this.emailsData.selectedMailConnector ? 'sendoutDownloadLink' : this.thirdPartyData.payload || this.thirdPartyData.selectedOutboundConnector ? 'forwardToThirdParty' : 'downloadFileFromNiotix';
      this.searchOperator = criteria.search_operator || 'AND';
      this.showStructureSection = this.csvOptions.clusterPerPacket;
      this.selectedStates = [];
      this.customProperties = criteria.customProperties || [];
      this.references = criteria.references || [];
      this.updateFilter(this.search, this.searchOperator).then(() => {
        const validValueTypes = ['string', 'number', 'boolean', 'json'];
        (criteria.stateIdentifiers || []).forEach(item => {
          const lastDashIndex = item.lastIndexOf('-');
          const key = lastDashIndex > 0 ? item.substring(0, lastDashIndex) : item;
          const valueType = lastDashIndex > 0 ? item.substring(lastDashIndex + 1) : null;
          if (validValueTypes.includes(valueType)) {
            this.selectedStates.push(`${key}-${valueType}`);
          } else {
            const matchingIdentifiers = this.stateIdentifiers.filter(identifier => identifier.key === key);
            matchingIdentifiers.forEach(identifier => {
              this.selectedStates.push(`${identifier.key}-${identifier.valueType}`);
            });
          }
        });
      }).catch(error => {
        console.error(error);
      });
      this.dialogIsReady = true;
    },
    resetDialog() {
      this.isReadonly = false;
      this.name = null;
      this.accountId = null;
      this.filter = [];
      this.filterType = 'digitalTwin';
      this.frequency = {
        repeat: 'monthly',
        month: null,
        day: null,
        hour: null,
        minute: null,
        weekDay: null
      };
      this.validFrequency = false;
      this.timeRange = TIME_RANGE_OPTIONS.LAST_HOUR;
      this.selectedAggregationKey = AGGREGATE_FUNCTIONS.ALL;
      this.searchOperator = 'AND';
      this.searchItems = [];
      this.search = [];
      this.allDriversVariables = [];
      this.stateIdentifiers = [];
      this.customProperties = [];
      this.references = [];
      this.drivers = [];
      this.selectedStates = [];
      this.timezone = null;
      this.emailsData = {
        emails: [''],
        selectedMailConnector: null,
        subject: '',
        html: '',
        attachFile: false
      };
      this.csvOptions = {
        headers: [],
        includeHeaders: true,
        clusterPerPacket: false
      };
      this.thirdPartyData = {
        selectedOutboundConnector: null,
        payload: null
      };
      this.deviceBridgesForAccount = [];
      this.selectedOutboundConnector = null;
      this.accountId = null;
      this.selectedOption = 'downloadFileFromNiotix';
    },
    updateFilter(search, operator) {
      this.filter = search;
      this.searchOperator = operator;
      return this.fetchFilterDeviceCount(this.filterType, this.filter, this.searchOperator);
    },
    fetchFilterDeviceCount(type, filter) {
      const searchItems = (filter || []).map(item => ({
        condition: item.param && item.condition,
        variable: item.param,
        // support item.search.value === null, so do not simply have a >search.value || search< expression
        search: (item.search || {}).value === undefined ? item.search : item.search.value,
        key: item.key
      }));
      const reqFilters = this.accountId ? [{
        type: 'tenantIds',
        ids: [this.accountId]
      }] : [];
      reqFilters.push({
        type: 'scopeIds',
        ids: [this.parentScopeId].filter(v => v != null)
      });
      if (searchItems.length === 0) {
        // if there are no search items, in case the search filter was emptied, reset the total count
        // and return. do not search for all available devices.
        this.searchTotalCount = null;
        this.allDriversVariables = [];
        this.stateIdentifiers = [];
        this.customProperties = [];
        this.references = [];
        this.drivers = [];
        this.selectedStates = [];
        return Promise.resolve();
      }
      const apiMethod = type === 'virtualDevice' ? ApiService.virtualDeviceFetch : ApiService.digitalTwinsFetch;
      const apiParams = [this,
      // context
      null,
      // userId
      [],
      // scopeIds
      reqFilters,
      // filters
      null,
      // options
      {
        variable: 'id',
        direction: 'ASC'
      },
      // orderBy
      0,
      // offset
      1,
      // limit
      searchItems];
      if (type === 'virtualDevice') {
        apiParams.push(undefined, true,
        // include identifiers
        true,
        // include customProperties
        true,
        // include drivers
        this.searchOperator);
      } else {
        apiParams.push(true,
        // include identifiers
        true,
        // include customProperties
        true // include references
        );
      }
      return apiMethod(...apiParams).then(result => {
        this.searchTotalCount = result.totalCount;
        this.stateIdentifiers = (result.identifiers || []).sort((a, b) => a.key.localeCompare(b.key, undefined, {
          numeric: true
        }));
        this.customProperties = (result.properties || []).sort((a, b) => a.keyValue.localeCompare(b.keyValue, undefined, {
          numeric: true
        }));
        if (type === 'digitalTwin') {
          this.references = result.references.sort((a, b) => a.key.localeCompare(b.key));
        }
        this.drivers = result.drivers || [];
      }).catch(error => {
        console.error(error);
        this.searchTotalCount = -1;
        this.allDriversVariables = [];
        this.stateIdentifiers = [];
        this.customProperties = [];
        this.references = [];
        this.drivers = [];
        this.selectedStates = [];
      });
    },
    fromCrontab(crontab) {
      const [minute, hour, day, month, weekDay] = crontab.split(' ');
      let freq = null;
      if (minute >= 0, hour >= 0, day >= 1, month >= 1) {
        freq = 'yearly';
      } else if (minute >= 0, hour >= 0, weekDay >= 1) {
        freq = 'weekly';
      } else if (minute >= 0, hour >= 0, day >= 1) {
        freq = 'monthly';
      } else if (minute >= 0, hour >= 0) {
        freq = 'daily';
      } else if (minute >= 0) {
        freq = 'hourly';
      }
      return {
        repeat: freq,
        month,
        weekDay: parseInt(weekDay),
        day,
        hour,
        minute
      };
    },
    toCrontab(frequency) {
      // Convert null or undefined values to '*'
      for (let key in frequency) {
        if (frequency[key] === null || frequency[key] === undefined) {
          frequency[key] = '*';
        }
      }
      return `${frequency.minute} ${frequency.hour} ${frequency.repeat === 'weekly' ? '*' : frequency.day} ${frequency.month} ${frequency.repeat !== 'weekly' ? '*' : frequency.weekDay}`;
    },
    handleSave() {
      const search_items = this.filter.map(item => ({
        condition: item.param && item.condition,
        variable: item.param,
        // support item.search.value === null, so do not simply have a >search.value || search< expression
        search: (item.search || {}).value === undefined ? item.search : item.search.value,
        key: item.key
      }));
      const payload = {
        active: true,
        tenantId: this.accountId,
        parentId: this.parentId,
        title: this.name,
        timeExpression: this.toCrontab(this.frequency),
        timezone: this.timezone,
        jobType: 'deviceStatesCsvExport',
        parameters: {
          criteria: {
            type: this.filterType,
            search_items: JSON.parse(JSON.stringify(search_items)),
            search_operator: this.searchOperator,
            stateIdentifiers: this.selectedStates,
            customProperties: this.customProperties,
            references: this.references,
            range: this.timeRange,
            aggregateFunction: this.dataAggregationObj.functionName.split('-')[0],
            aggregatePeriod: this.dataAggregationObj.aggregatePeriod
          },
          emailsData: this.selectedOption === 'sendoutDownloadLink' && this.emailsData ? {
            emails: this.emailsData.emails,
            bridgeId: get(this.emailsData, 'selectedMailConnector.id', null),
            subject: this.emailsData.subject,
            html: this.emailsData.html,
            attachFile: this.emailsData.attachFile
          } : {},
          thirdPartyData: this.selectedOption === 'forwardToThirdParty' ? {
            bridgeId: get(this.thirdPartyData, 'selectedOutboundConnector.id', null),
            payload: this.thirdPartyData.payload
          } : {},
          csvOptions: this.csvOptions.includeHeaders ? {
            headers: (this.csvOptions.headers || []).map(c => {
              return {
                name: c.name,
                mappedValue: c.mappedValue,
                isCustomProperty: c.isCustomProperty,
                isReferenceProperty: c.isReferenceProperty,
                isInParsedState: c.isInParsedState
              };
            }),
            includeHeaders: true,
            clusterPerPacket: this.csvOptions.clusterPerPacket
          } : {
            includeHeaders: false
          }
        }
      };
      ApiService.createJobDefinition(payload).then(() => {
        this.$snack(this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.createSuccess'), 'success');
        this.$emit('save');
      }).catch(err => {
        this.$snack(this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.createError'), 'error');
        console.error(err);
      }).finally(() => {
        this.close();
      });
    },
    close() {
      this.resetDialog();
      this.$emit('close');
    },
    fetchBridges() {
      this.mailConnectors = [];
      this.outboundConnectors = [];
      if (this.accountId === null) {
        return;
      }
      Promise.all([ApiService.getBridgeTypes().then(bridgeTypes => {
        return bridgeTypes.filter(type => {
          return Object.keys(get(type, 'manifest.commands.instance', {})).length > 0;
        });
      }), ApiService.getBridgesForTenant(this.accountId)]).then(results => {
        this.bridgeTypes = results[0];
        this.mailConnectors = results[1].filter(bridgeInstance => {
          return bridgeInstance.type === 'bridge-mail';
        }).map(bridge => {
          return bridge.state === 'active' ? bridge : {
            ...bridge,
            name: `${bridge.name} (inactive)`,
            disabled: true
          };
        });
        this.outboundConnectors = results[1].filter(bridgeInstance => {
          return bridgeInstance.type === 'bridge-mqtt-outbound' || bridgeInstance.type === 'bridge-webhook';
        }).map(bridge => {
          return bridge.state === 'active' ? bridge : {
            ...bridge,
            name: `${bridge.name} (inactive)`,
            disabled: true
          };
        });
        if (get(this.editObject, 'parameters.emailsData.bridgeId')) {
          const bridgeId = this.editObject.parameters.emailsData.bridgeId;
          const matchedConnector = this.mailConnectors.find(c => Number(c.id) === bridgeId);
          if (matchedConnector) {
            this.emailsData = {
              ...this.emailsData,
              selectedMailConnector: matchedConnector
            };
          }
        } else if (!this.editObject) {
          this.emailsData.selectedMailConnector = this.mailConnectors[0];
        }
        if (!this.selectedOutboundConnector) {
          this.selectedOutboundConnector = this.outboundConnectors[0];
        }
      }).catch(error => {
        console.error('Error fetching bridges', error);
        this.$snack(this.$i18n_t('Connectors.Connectors.errors.connectionError'), 'error');
      });
    },
    populateDrivers() {
      this.allDriversVariables = [];
      const driversLatestVersionVariables = this.drivers.map(d => {
        let latestVersionNumber = 0; // default
        let latestVersion = null;
        if (Array.isArray(d.versions)) {
          d.versions.forEach(dv => {
            if (dv.version === 'default') {
              if (latestVersionNumber === 0) {
                latestVersion = dv;
              }
              return;
            }
            if (dv.version > latestVersionNumber) {
              latestVersionNumber = dv.version;
              latestVersion = dv;
            }
          });
        }
        if (latestVersion && latestVersion.parser) {
          return latestVersion.parser.config.variables;
        }
      });
      const tmp = {};
      driversLatestVersionVariables.forEach(variable => {
        if (variable) {
          Object.keys(variable).forEach(variableKey => {
            if (!tmp[variableKey]) {
              tmp[variableKey] = 0;
            }
            tmp[variableKey]++;
          });
        }
      });
      Object.keys(tmp).forEach(variableKey => {
        this.allDriversVariables.push({
          title: variableKey,
          count: tmp[variableKey]
        });
      });
    }
  }
};